module.exports = __webpack_public_path__ + "img/1269766323.b55ab097.jpg";